import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
import { Label } from 'reactstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';

import AppButton from 'components/App/Button';
import AppInputValidation from 'components/App/InputValidation';
import AuthTermsNotice from 'components/App/AuthTermsNotice';
import Meta from 'components/App/Meta';
import images from 'assets/images';
// import { LOGIN_TYPE } from 'constants/index';

import styles from './ForgotPassword.module.scss';

const NewPassword = (props) => {
  const {
    // loginType,
    forgotPasswordLoading,
    onSubmitNewPassword,
  } = props;

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const validationStep3 = useFormik({
    initialValues: {
      password: '',
      confirmPassword: '',
    },
    validationSchema: Yup.object({
      password: Yup.string()
        .required('Vui lòng nhập mật khẩu mới')
        .matches(
          /^(?=.*[a-zA-Z])(?=.*\d)(?=.*[^a-zA-Z0-9\s]).{8,32}$/,
          'Mật khẩu phải dài từ 8 đến 32 ký tự, bao gồm chữ, số và ký tự đặc biệt',
        ),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref('password'), null], 'Mật khẩu xác nhận không khớp')
        .required('Vui lòng xác nhận lại mật khẩu'),
    }),
    onSubmit: (values) => {
      onSubmitNewPassword(values);
    },
  });

  const togglePasswordVisibility = useCallback(() => {
    setShowPassword((prev) => !prev);
  }, []);

  const toggleConfirmPasswordVisibility = useCallback(() => {
    setShowConfirmPassword((prev) => !prev);
  }, []);

  const renderNewPasswordForm = () => {
    const isPasswordInvalid = validationStep3.errors.password
      && validationStep3.touched.password;
    const isConfirmPasswordInvalid = validationStep3.errors.confirmPassword
      && validationStep3.touched.confirmPassword;

    return (
      <form onSubmit={(e) => { e.preventDefault(); validationStep3.handleSubmit(); }}>
        <div className={styles.FormGroup}>
          <Label className={styles.FormLabel}>
            Mật khẩu mới
            <code>*</code>
          </Label>
          <div className={styles.PasswordWrapper}>
            <AppInputValidation
              inputClassName={styles.FormInput}
              placeholder="Nhập mật khẩu mới"
              name="password"
              type={showPassword ? 'text' : 'password'}
              validation={validationStep3}
            />
            <button
              type="button"
              className={`${styles.ShowHideButton} ${isPasswordInvalid ? styles.ShowHideButtonInvalid : ''}`}
              onClick={togglePasswordVisibility}
              aria-label={showPassword ? 'Ẩn mật khẩu' : 'Hiển thị mật khẩu'}
            >
              <i className={`fas ${showPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
            </button>
          </div>
        </div>

        <div className={styles.FormGroup}>
          <Label className={styles.FormLabel}>
            Nhập lại mật khẩu
            <code>*</code>
          </Label>
          <div className={styles.PasswordWrapper}>
            <AppInputValidation
              inputClassName={styles.FormInput}
              placeholder="Nhập lại mật khẩu"
              name="confirmPassword"
              type={showConfirmPassword ? 'text' : 'password'}
              validation={validationStep3}
            />
            <button
              type="button"
              className={`${styles.ShowHideButton} ${isConfirmPasswordInvalid ? styles.ShowHideButtonInvalid : ''}`}
              onClick={toggleConfirmPasswordVisibility}
              aria-label={showConfirmPassword ? 'Ẩn mật khẩu' : 'Hiển thị mật khẩu'}
            >
              <i className={`fas ${showConfirmPassword ? 'fa-eye' : 'fa-eye-slash'}`} />
            </button>
          </div>
        </div>

        <AppButton
          classes={styles.SubmitBtn}
          loading={forgotPasswordLoading}
          type="submit"
        >
          XÁC NHẬN
        </AppButton>

        <AuthTermsNotice className={styles.Terms} />
      </form>
    );
  };

  return (
    <div className={styles.Container}>
      <Meta name="Quên mật khẩu" />

      <header className={styles.Header}>
        <div className={styles.HeaderContent}>
          <img
            src={images.logoBookeseFull.default}
            alt="logo-bookese"
            className={styles.HeaderLogo}
          />
        </div>
      </header>

      <main className={styles.Main}>
        <div className={styles.Card}>
          <div className={styles.CardHeader}>
            <h1 className={styles.CardTitle}>Quên mật khẩu</h1>
            <p className={styles.CardDescription}>
              Khôi phục và thiết lập lại mật khẩu
            </p>
          </div>
          <div className={styles.CardBody}>
            {renderNewPasswordForm()}
          </div>
        </div>
      </main>

      <footer className={styles.Footer}>
        <p className={styles.Copyright}>
          © 2022 Bookese. Design and Develop by Wiicamp
        </p>
      </footer>
    </div>
  );
};

NewPassword.propTypes = {
  // loginType: PropTypes.string.isRequired,
  forgotPasswordLoading: PropTypes.bool.isRequired,
  onSubmitNewPassword: PropTypes.func.isRequired,
};

export default NewPassword;
